export default "__VITE_ASSET__BgFso$6j__"